import React from 'react'
import { Trash, X } from '@phosphor-icons/react'

const ModalDeleteProject = ({ open, onClose, onDelete, project }) => {
  return (
    <dialog className={`modal ${open ? 'modal-open' : ''}`}>
        <div className="modal-box">
          <h3 className="font-bold text-lg">Confirm Deletion</h3>
          <p className="py-4">Are you sure you want to delete <span
            className="font-bold">{project?.name}</span> ? This action cannot be
            undone.</p>
          <div className="modal-action">
            <button className="btn btn-outline btn-sm" onClick={onClose}>
              <span className="mr-2">Cancel</span>
              <X size={16}/>
            </button>
            <button className="btn btn-error btn-outline btn-sm"
                    onClick={() => {
                      onDelete()
                      onClose()
                    }}>
              <span className="mr-2">Delete</span>
              <Trash size={16}/>
            </button>
          </div>
        </div>
        <form method="dialog" className="modal-backdrop bg-base-100/20" onClick={onClose}>
          <button>close</button>
        </form>
      </dialog>
  )
}

export default ModalDeleteProject